// @flow
import * as React from 'react'

export const Smartphone = () => {
  return (
    <svg viewBox="0 0 336 496" version="1.1">
      <defs>
        <linearGradient
          x1="50%"
          y1="50%"
          x2="50%"
          y2="100%"
          id="linearGradient-1"
        >
          <stop stopColor="#412A4C" offset="0%"></stop>
          <stop stopColor="#412A4C" offset="100%"></stop>
        </linearGradient>
        <path
          d="M65,0 L192,0 C208.016258,-2.94213882e-15 221,12.9837423 221,29 L221,341 C221,357.016258 208.016258,370 192,370 L65,370 C48.9837423,370 36,357.016258 36,341 L36,29 C36,12.9837423 48.9837423,2.94213882e-15 65,0 Z"
          id="path-2"
        ></path>
        <filter
          x="-57.8%"
          y="-23.0%"
          width="215.7%"
          height="157.8%"
          filterUnits="objectBoundingBox"
          id="filter-3"
        >
          <feOffset
            dx="0"
            dy="22"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="32"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          ></feColorMatrix>
          <feOffset
            dx="0"
            dy="12"
            in="SourceAlpha"
            result="shadowOffsetOuter2"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="22"
            in="shadowOffsetOuter2"
            result="shadowBlurOuter2"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0"
            type="matrix"
            in="shadowBlurOuter2"
            result="shadowMatrixOuter2"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
          </feMerge>
        </filter>
        <filter
          x="-42.2%"
          y="-15.1%"
          width="184.3%"
          height="142.2%"
          filterUnits="objectBoundingBox"
          id="filter-4"
        >
          <feGaussianBlur
            stdDeviation="10"
            in="SourceAlpha"
            result="shadowBlurInner1"
          ></feGaussianBlur>
          <feOffset
            dx="0"
            dy="-8"
            in="shadowBlurInner1"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
            type="matrix"
            in="shadowInnerInner1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Desktop-Global"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Toggl_Job_overview"
          transform="translate(-556.000000, -3404.000000)"
        >
          <g id="02" transform="translate(436.000000, 3293.000000)">
            <g id="smartphone" transform="translate(147.000000, 152.000000)">
              <g id="base">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-3)"
                  xlinkHref="#path-2"
                ></use>
                <use
                  fill="url(#linearGradient-1)"
                  fillRule="evenodd"
                  xlinkHref="#path-2"
                ></use>
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-4)"
                  xlinkHref="#path-2"
                ></use>
              </g>
              <path
                d="M47,198.602217 L47,100.314039 L47,341.761084 C47,350.656676 54.3694216,358 63.3146667,358 L191.685333,358 C200.630578,358 208,350.656676 208,341.761084 L208,195.183498 L208,27.2389163 C208,18.3433237 200.630578,11 191.685333,11 L175.356713,11 C173.704619,11 172.365333,12.3392861 172.365333,13.9913793 L172.365333,13.9913793 L172.365333,13.9913793 C172.507987,19.7368629 167.902099,24.3264402 162.061333,24.2475369 L92.5093333,24.2475369 C86.5835243,24.3264402 81.9776358,19.7368629 82.2053333,13.9913793 C82.2053333,12.3392861 80.8660472,11 79.213954,11 L77.912,11 L77.912,11 L73.6186667,11 L69.7546667,11 C69.6325879,11 67.5750799,11 63.3146667,11 C54.3694216,11 47,18.3433237 47,27.2389163 L47,102.450739"
                id="Mask"
                fill="#564260"
              ></path>
              <path
                d="M134.247897,172.389867 C135.534169,171.044949 137.515673,170.630547 139.23315,171.347275 C140.950626,172.064002 142.049687,173.763969 141.998271,175.62421 C141.942769,177.632242 140.562932,179.360261 138.616893,179.858832 C136.670854,180.357402 134.630046,179.505744 133.615763,177.771788 C132.60148,176.037832 132.859435,173.841635 134.247897,172.389867 M159.497274,211.818139 C159.381879,208.425926 158.399165,204.839981 155.886542,202.473409 C153.083571,199.833333 149.02615,198.621557 145.255355,198.621557 L128.444977,198.621557 C126.784784,198.621557 125.314435,197.3566 125.314435,195.795347 C125.315848,194.508223 126.170074,193.384974 127.391536,193.064103 C127.387814,193.060304 127.678161,192.988129 127.987121,192.885565 C131.055217,194.327913 134.399263,195.05584 137.777045,195.016619 C142.962354,195.016619 148.155108,193.47056 151.959405,189.861823 C155.663197,186.348053 157.394116,181.436372 157.394116,176.406933 C157.394116,171.377493 155.663197,166.469611 151.959405,162.95584 C150.87834,161.933652 149.673689,161.056652 148.37473,160.346154 C151.944516,161.18566 155.629696,160.144824 158.164653,155.707977 L151.021359,150.5 L145.065512,158.917854 C142.707208,158.163313 140.248501,157.786566 137.777045,157.801045 C132.595458,157.801045 127.398981,159.347104 123.594684,162.95584 C119.890892,166.469611 118.163696,171.381292 118.163696,176.406933 C118.163696,181.432574 119.890892,186.348053 123.594684,189.861823 C123.918533,190.165717 124.249827,190.454416 124.592288,190.731719 C124.227493,190.92925 123.896199,191.107787 123.896199,191.107787 C122.151298,192.127717 120.567513,193.410971 119.198524,194.914055 C116.849687,197.451567 114.50085,201.250237 114.50085,206.306268 C114.50085,206.306268 114.173278,217.090693 126.379042,217.090693 L135.219753,217.090693 C137.255908,217.090693 139.329287,218.405033 139.329287,220.467711 C139.329197,221.189364 139.123569,221.895432 138.737425,222.5 L155.648308,222.5 C158.196267,219.556541 159.569711,215.744885 159.497274,211.818139 M177.267659,173.25089 C179.071832,171.548668 181.92999,171.588681 183.684282,173.340722 C185.438573,175.092762 185.438573,177.907238 183.684282,179.659278 C181.92999,181.411319 179.071832,181.451332 177.267659,179.74911 C175.577447,177.902694 175.577447,175.097306 177.267659,173.25089 M207.49712,210.818139 C207.384695,207.425926 206.391614,203.839981 203.865814,201.473409 C201.040215,198.833333 196.955465,197.621557 193.163017,197.621557 L173.518738,197.477208 C172.278323,197.477208 171.333958,196.694682 171.333958,195.536087 C171.333958,194.582621 171.802393,193.15812 172.990344,192.922602 C175.339535,193.660139 177.786203,194.029078 180.245461,194.016619 C185.465697,194.016619 190.697177,192.47056 194.523351,188.861823 C198.252092,185.348053 199.994669,180.436372 199.994669,175.406933 C199.994669,170.377493 198.252092,165.469611 194.523351,161.95584 C193.435004,160.933652 192.222239,160.056652 190.91453,159.346154 C194.508362,160.18566 198.218365,159.144824 200.770397,154.707977 L193.582735,149.5 L187.583022,157.917854 C185.208833,157.163313 182.733565,156.786566 180.245461,156.801045 C175.028972,156.801045 169.797493,158.347104 165.96757,161.95584 C162.242577,165.469611 160.5,170.381292 160.5,175.406933 C160.5,180.432574 162.242577,185.348053 165.96757,188.861823 C167.062695,189.887964 168.283077,190.767561 169.598876,191.479107 C168.643805,192.21362 167.751268,193.028131 166.930672,193.914055 C164.562266,196.451567 162.197607,200.250237 162.197607,205.306268 C162.197607,205.306268 161.871577,216.090693 174.159557,216.090693 L183.059817,216.090693 C185.109687,216.090693 187.193285,217.405033 187.193285,219.467711 C187.194309,220.18898 186.988607,220.895018 186.601183,221.5 L203.622228,221.5 C206.188947,218.557507 207.571879,214.745198 207.49712,210.818139 M228,205.559085 L228,189.614962 C224.35175,190.081473 223.084738,187.496855 223.084738,184.934809 L223.084738,146 L205,146 L205,187.842975 C205,193.038547 205.771387,197.372579 207.638367,200.10016 C210.504051,204.249846 214.387071,206.96614 222.104666,207 C223.528192,206.936043 225.905703,206.653879 228,205.559085 M94.4447685,186.028865 C92.5043941,188.170411 89.3132056,188.624108 86.8529768,187.108205 C84.3927481,185.592302 83.3627263,182.537648 84.4025699,179.841228 C85.4424135,177.144807 88.2565775,175.572998 91.0974258,176.101916 C93.9382742,176.630834 95.9983796,179.11015 95.9983872,182.000173 C96.034103,183.4958 95.4754022,184.944568 94.4447685,186.028865 M107.712876,164.424426 C102.96189,159.574277 96.4743094,157.5 90.0018958,157.5 C83.5294823,157.5 77.0381103,159.574277 72.2871237,164.424426 C67.6612629,169.144933 65.5,175.745253 65.5,182.498093 C65.5,189.250934 67.6612629,195.855067 72.2871237,200.575574 C77.0343187,205.42191 83.5256906,207.5 90.0018958,207.5 C96.4781011,207.5 102.96189,205.42191 107.712876,200.575574 C112.338737,195.855067 114.5,189.254747 114.5,182.498093 C114.5,175.74144 112.338737,169.144933 107.712876,164.424426 M59.2479573,189.678919 C56.1708247,189.678919 54.9125177,188.753423 53.7762283,187.335081 C53.0364964,186.409584 52.6704434,185.047675 52.6704434,183.283212 L52.6704434,175.028987 L63,175.028987 L63,160.236092 L52.6704434,160.236092 L52.6704434,146 L39.469659,146 L39.469659,151.323486 C39.469659,157.218823 34.8901841,161.996793 29.2468679,161.996793 C28.8300098,161.995318 28.4136249,161.968935 28,161.917787 L28,175.028987 L34.9321277,175.028987 L34.9321277,188.207907 C34.9321277,193.395954 35.8853906,197.39139 37.7919163,200.115209 C40.7355921,204.279943 43.9995642,207 51.972655,207 C56.5940734,207 60.4605077,205.957876 63,204.569631 L63,189.065684 C61.7964731,189.489539 60.5257197,189.697231 59.2479573,189.678919"
                id="logo"
                fill="#FFDE91"
                transform="translate(128.000000, 184.250000) rotate(-90.000000) translate(-128.000000, -184.250000) "
              ></path>
              <circle
                id="Oval"
                stroke="#FFFFFF"
                strokeWidth="6"
                fill="#564260"
                cx="36.5"
                cy="270.5"
                r="39.5"
              ></circle>
              <path
                d="M47.886826,260 L51,263 L34.3964054,279 L34.315,278.922 L34.3017973,278.935029 L26,270.935029 L29.113174,267.935029 L34.382,273.013 L47.886826,260 Z"
                id="Combined-Shape"
                fill="#FFDE91"
              ></path>
              <rect
                id="Rectangle"
                fill="#FFDE91"
                x="190"
                y="99"
                width="118"
                height="72"
                rx="4"
              ></rect>
              <rect
                id="Rectangle-Copy-8"
                fill="#FFFFFF"
                x="190"
                y="206"
                width="119"
                height="4"
                rx="2"
              ></rect>
              <rect
                id="Rectangle-Copy-9"
                fill="#FFFFFF"
                x="190"
                y="225"
                width="119"
                height="4"
                rx="2"
              ></rect>
              <rect
                id="Rectangle-Copy-10"
                fill="#FFFFFF"
                x="190"
                y="243"
                width="119"
                height="4"
                rx="2"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
